module.exports = __webpack_public_path__ + "img/Blätter.b36018bb.jpg";